import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import {
  ApiResponse,
  SearchSkillsParams,
  SkillApiResponseItem,
  StaticSkillItem,
  StaticSkillsApiResponse,
} from '@/shared/types';

export const useSearchedSkillQuery = ({
  query,
  selected,
}: SearchSkillsParams) => {
  return useQuery({
    queryKey: ['profileSearchSkillsApi', query, selected],
    queryFn: async () => {
      const response = await clientAxios.get('/profileSearchSkillsApi/', {
        params: { query, selected },
      });
      return response.data.data.map((item: SkillApiResponseItem) => ({
        count: item.total_uses,
        value: item.name,
      }));
    },
  });
};

export const useStaticSkillQuery = (): UseQueryResult<
  StaticSkillItem[],
  Error
> => {
  return useQuery({
    queryKey: ['profileStaticSkillsApi'],
    queryFn: async () => {
      const response = await clientAxios.get<
        ApiResponse<StaticSkillsApiResponse>
      >('/profileStaticSkillsApi/');
      return Object.keys(response.data.data).map((key) => ({
        key: key.toLowerCase(),
        iconUrl: response.data.data[key].image,
        value: response.data.data[key].name,
      }));
    },
  });
};
